import React, { useEffect, useState } from 'react';
import { Card } from 'antd';
import PurchaseForm from '../../components/Purchase/PurchaseForm';
import { usePurchase } from '../../store/purchaseContext';
import { useParams, useNavigate } from 'react-router-dom';

const PurchaseFormPage: React.FC = () => {
    const { id } = useParams<{ id: string }>();
    const { purchases, fetchPurchases } = usePurchase();
    const [editPurchase, setEditPurchase] = useState<any | undefined>(undefined);
    const navigate = useNavigate();

    useEffect(() => {
        fetchPurchases();
    }, []);

    useEffect(() => {
        if (id) {
            const purchase = purchases.find((p: any) => p.id === id || p._id === id);
            setEditPurchase(purchase);
        } else {
            setEditPurchase(undefined);
        }
    }, [id, purchases]);

    return (
        <div style={{ padding: 16 }}>
            <Card title={editPurchase ? "Edit Purchase" : "Add Purchase"}>
                <PurchaseForm
                    editPurchase={editPurchase}
                    onFinishEdit={() => navigate('/purchase/list')}
                />
            </Card>
        </div>
    );
};

export default PurchaseFormPage;
